import {Controller} from "stimulus"
import EventEmitter from "./../utils/EventEmitter"

/**
 * Base class for modals
 */
export default class extends Controller {

    static targets = [
    ]

    initialize(){
        this.initEvents()
        this.maybeStartOpen()
    }

    maybeStartOpen(){
        if ( this.startOpen ) {
            const timer = setTimeout(() => {
                this.open()
                clearTimeout(timer)
            }, this.startOpenDelay)
        }
    }

    initEvents() {
        EventEmitter.on(`modal-before-opened-${this.name}`, e => this.beforeOpened(e))
        EventEmitter.on(`modal-after-closed-${this.name}`, e => this.afterClosed(e))
    }

    open(){
        EventEmitter.emit(`modal-open-now`, {name: this.name})
    }

    close(){
    }

    beforeOpened(e) {
        console.log("before opened !", this.name)
    }

    afterClosed(e) {
        console.log("after closed !", this.name)
    }

    get name(){
        return this.data.get("name")
    }

    get startOpen(){
        const val = parseInt(this.data.get("startOpen"))
        return val
    }

    get startOpenDelay(){
        let val = this.data.get("startOpenDelay")
        val = val && val !== "" ? parseFloat(this.data.get("startOpenDelay")) * 1000 : 0
        return isNaN(val) ? 0 : val
    }

}